import React, {Component} from "react";
import {Alert, Form, Input, Modal} from "antd";
import PropTypes from "prop-types";

export default class CorrectProductSoldModal extends Component {
  static propTypes = {
    returnProduct: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  state = {
    hasErrors: false,
    submitting: false,
    visible: false,
    eventId: '',
    productId: '',
    productName: '',
    sku: '',
    quantity: 0,
    note: '',
    error: '',
  };

  open = (eventId, productId, productName, sku, quantity) => this.setState({
    visible: true,
    eventId,
    productId,
    productName,
    sku,
    quantity,
    note: '',
    error: '',
  });

  _handleOk = async() => {
    this.setState({submitting: true});
    const {eventId, productId, sku, quantity, note} = this.state;
    const returnReasonId = 'correct-sold-product';
    try {
      await this.props.returnProduct({productId, sku, quantity, returnReasonId, note, originId: eventId});
      this.setState({submitting: false, visible: false});
      this.props.onClose();
    } catch (e) {
      this.setState({submitting: false, error: e.message});
    }
  };

  _handleCancel = () => {
    this.setState({visible: false});
    this.props.onClose();
  };

  _onChange = e => this.setState({[e.target.name]: e.target.value});

  render() {
    const {error, hasErrors, note, productName, quantity, submitting, visible} = this.state;
    return (
      <Modal
        title="Correct Product Sold"
        visible={visible}
        okText="Correct"
        okButtonProps={{
          disabled: hasErrors,
          loading: submitting,
        }}
        onOk={this._handleOk}
        onCancel={this._handleCancel}
      >
        <Form onSubmit={e => e.preventDefault()}>
          This will undo the selling of {quantity} <b>{productName}</b>
          <Form.Item label="Note (Optional)">
            <Input value={note} onChange={this._onChange} />
          </Form.Item>
          {error ? <Alert type="error" message={error} /> : null}
        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Product/CorrectProductSoldModal.js